import React, { Component, Fragment } from 'react';
import { IFiltersBreakpointProps, IFiltersProps, IFiltersState } from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import ClearButton from './styledComponents/ClearButton';
import CloseButton from './styledComponents/CloseButton';
import ChildFilters from './styledComponents/ChildFilters';
import Toolbar from './styledComponents/Toolbar';
import FilterIndicator from './styledComponents/FilterIndicator';
import DialogHeader from './styledComponents/DialogHeader';
import FiltersHeaderToggle from './styledComponents/FiltersHeaderToggle';
import FiltersDialog from './styledComponents/FiltersDialog';
import ActiveFiltersWrapper from './styledComponents/ActiveFiltersWrapper';
import ActiveFiltersHeading from './styledComponents/ActiveFiltersHeading';
import ActiveFilterPill from './styledComponents/ActiveFilterPill';
import Filter from '../Filter';
import AccordionFilter from '../AccordionFilter';
import { computed } from 'mobx';
import { utils } from '@kurtosys/ksys-app-template';
import { IFilterProps } from '../Filter/models';
import { FiltersStore } from './stores/FiltersStore';
import Breakpoint from '@kurtosys/ksys-app-components/dist/components/base/Breakpoint';

@inject('appStore', 'filtersStore')
@observer
export class Filters extends Component<IFiltersProps, IFiltersState> {
	static configurationKey: 'filters' = 'filters';
	static styleKey: 'filters' = 'filters';
	constructor(props: IFiltersProps) {
		super(props);
	}

	@computed
	get childFilters(): IFilterProps[] {
		const { filtersStore } = this.props;
		if (!filtersStore || !filtersStore.hasFilters) {
			return [];
		}
		return filtersStore.childFilters.filter((f) => !utils.typeChecks.isNullOrEmpty(f.items));
	}

	renderFilters(filtersStore: FiltersStore, props: IFiltersBreakpointProps) {
		return (
			<Fragment>
				{props.mode === 'accordion' &&
					this.childFilters.map((filter) => {
						return <AccordionFilter {...filter} />;
					})}
				{props.mode === 'dropdown' && (
					<ChildFilters>
						{filtersStore.childFilters.map((filter) => {
							return <Filter key={filter.code} {...filter} />;
						})}
					</ChildFilters>
				)}
			</Fragment>
		);
	}

	openFilterToggleIconProps(breakpointProps: IFiltersBreakpointProps) {
		if (breakpointProps.filtersHeaderToggle && breakpointProps.filtersHeaderToggle.openFiltersIcon) {
			return { ...breakpointProps.filtersHeaderToggle.openFiltersIcon };
		}
		return {};
	}
	closeFilterToggleIconProps(breakpointProps: IFiltersBreakpointProps) {
		if (breakpointProps.filtersHeaderToggle && breakpointProps.filtersHeaderToggle.closeFiltersIcon) {
			return {
				...breakpointProps.filtersHeaderToggle.closeFiltersIcon,
			};
		}
		return {};
	}

	closeDialodIconProps(breakpointProps: IFiltersBreakpointProps) {
		if (breakpointProps.filtersHeaderToggle && breakpointProps.filtersHeaderToggle.closeDialogIcon) {
			return {
				...breakpointProps.filtersHeaderToggle.closeDialogIcon,
			};
		}
		return {};
	}

	renderActiveFilters(filtersStore: FiltersStore) {
		const { activeFiltersProps, activeFilterPills } = filtersStore;
		return (
			activeFiltersProps.show &&
			activeFilterPills.length > 0 && (
				<ActiveFiltersWrapper>
					<ActiveFiltersHeading>{activeFiltersProps.heading}</ActiveFiltersHeading>
					{activeFilterPills.map((pillProps) => {
						return <ActiveFilterPill {...pillProps} />;
					})}
				</ActiveFiltersWrapper>
			)
		);
	}

	showToggleButton(breakpointProps: IFiltersBreakpointProps) {
		const { filtersHeaderToggle = {} } = breakpointProps;
		return filtersHeaderToggle !== {} && filtersHeaderToggle.showButton;
	}

	render() {
		const { className, filtersStore } = this.props;

		if (!filtersStore || !filtersStore.hasFilters) {
			return null;
		}

		const {
			breakpoints = [],
			mode,
			filterIndicatorText,
			filterToggleText,
			clearFilters,
			showFilters,
			toggleShowFilters,
		} = filtersStore;
		const hasBreakpoints = !utils.typeChecks.isNullOrEmpty(breakpoints);
		return (
			<Wrapper className={className}>
				{!hasBreakpoints && (
					<Toolbar>
						<FilterIndicator>{filterIndicatorText}</FilterIndicator>
						<ClearButton onClick={clearFilters} text={'Clear Filters'} />
					</Toolbar>
				)}
				{this.renderActiveFilters(filtersStore)}
				{hasBreakpoints &&
					breakpoints.map((breakpoint) => {
						const breakpointProps = {
							key: `${breakpoint.size}_${breakpoint.modifier}`,
							[breakpoint.size]: true,
							[breakpoint.modifier]: true,
						};
						{
							return (
								breakpoint.props && (
									<Breakpoint {...breakpointProps}>
										<Toolbar>
											{this.showToggleButton(breakpoint.props) && (
												<FiltersHeaderToggle
													iconProps={this.openFilterToggleIconProps(breakpoint.props)}
													onClick={toggleShowFilters}
												>
													{filterToggleText}
												</FiltersHeaderToggle>
											)}
											<FilterIndicator>{filterIndicatorText}</FilterIndicator>
											<ClearButton onClick={clearFilters} text={'Clear Filters'} />
										</Toolbar>

										{!this.showToggleButton(breakpoint.props) &&
											this.renderFilters(filtersStore, breakpoint.props || { mode })}

										{this.showToggleButton(breakpoint.props) && showFilters && (
											<FiltersDialog>
												<DialogHeader>
													<FiltersHeaderToggle
														onClick={toggleShowFilters}
														iconProps={this.closeFilterToggleIconProps(breakpoint.props)}
														iconPosition={
															breakpoint.props.filtersHeaderToggle &&
															breakpoint.props.filtersHeaderToggle
																.closeFiltersIconPosition
														}
													>
														{filterToggleText}
													</FiltersHeaderToggle>
													<FilterIndicator>{filterIndicatorText}</FilterIndicator>
													<ClearButton onClick={clearFilters} text={'Clear Filters'} />
													<CloseButton
														onClick={toggleShowFilters}
														iconProps={this.closeDialodIconProps(breakpoint.props)}
													/>
												</DialogHeader>
												{this.renderFilters(filtersStore, breakpoint.props || { mode })}
											</FiltersDialog>
										)}
									</Breakpoint>
								)
							);
						}
					})}
				{!hasBreakpoints && this.renderFilters(filtersStore, { mode })}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(Filters, 'filters');
